// styles.ts
import styled from "styled-components";

export const TagButton = styled.button`
	border: 1px solid #e20014;
	color: #e20014;
	background: #fff;
	font-size: 14px;
	padding: 2px 10px;
	border-radius: 16px;
	cursor: pointer;
	outline: none;
	transition: background 0.2s;
	&:hover {
		background: #ffe6ea;
	}
`;

export const TableWrapper = styled.div`
	max-height: 500px;
	overflow-y: auto;
`;

export const Table = styled.table`
	width: 100%;
	border-collapse: collapse;
`;

export const TableHead = styled.thead``;

export const TableHeaderRow = styled.tr`
	border-bottom: 1px solid #ccc;
`;

export const TableHeader = styled.th`
	padding: 8px;
	text-align: left;
`;

export const TableBody = styled.tbody``;

export const TableRow = styled.tr`
	cursor: pointer;

	&:hover {
		background-color: #f5f5f5;
	}
`;

export const TableCell = styled.td`
	padding: 8px;
	border-bottom: 1px solid #eee;
`;
